<div class="detail-container">
  @if (programPropertyResource.isLoading()) {
    <property-skeleton />
  }  @else if (programPropertyResource.error()) {
        <error-card/>
    } @else {
    @if (programPropertyResource.value(); as programProperty) {
      <div class="d-flex gap-4">
        <div>
          <section-header>{{ programProperty.name() }}</section-header>
            <div class="d-flex flex-wrap gap-4">
              <document-card [style.view-transition-name]="'card-image'" class="document-card">
                @if (programProperty.hasImageError()) {
                  <span class="text-center" card-content>{{ programProperty.name() }}</span>
                } @else {
                  <img card-content class="h-100" (error)="programProperty.handleImageError()" [src]="programProperty.thumbnailUrl()" alt="image" />
                }
                <span card-footer class="font-5">{{programProperty.name()}}</span>

              </document-card>
            </div>
        </div>
      </div>

      <div class="mt-4">
        <section-header>Program Properties</section-header>

        <div masonry class="masonry-columns">
          @for (category of programProperty.categories(); track $index) {
            <property-card>
              <div title class="d-flex align-items-center">
                @if(!category.hasImageError) {
                  <img height="50" src="{{category.thumbnailUrl()}}"/>
                }
                <span>{{ category.name() }}</span>
              </div>

              <div content class="d-flex flex-column gap-3 primary-text">
                <property-item-header />

                @for (property of category.properties(); track $index) {
                  <property-item-row [name]="property.name()" [value]="property.values()"></property-item-row>
                }
              </div>
            </property-card>
          } @empty {
            <empty-property-card />
          }
        </div>
      </div>

        @if (programProperty.projects(); as projects) {
            <div class="mt-4">
                <carousel [shouldAddBreadcrumb]="false" [dataSource]="projects" class="carousel-bottom-center carousel">
                    <span carousel-label>Projects ({{projects.length}})</span>
                </carousel>
            </div>
        }
    }
  }
</div>